import React from "react";
import { Card, Button } from "react-bootstrap";

const StarterCard = ({ scrollToConsult }) => {
  return (
    <div className="container d-flex justify-content-center align-items-center mb-5 ">
      <Card
        style={{
          width: "100%",
          padding: "40px",
          borderRadius: "32px",
        }}
        className="bg-theme"
      >
        <Card.Body>
          <Card.Title>
            <h2 className="fs-40 mb-4 fw-700 text-center text-white">
              Ready to Get Started?
            </h2>
          </Card.Title>
          <div className="d-flex justify-content-center">
            <div className="d-flex my-2 my-lg-0 me-1" onClick={scrollToConsult}>
              <a className="fs-14 btn btn-golden animate__animated animate__slideInUp">
                {" "}
                BOOK A FREE CONSULTATION{" "}
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default StarterCard;
